import { Icon } from "@/components/Icon";

const PDFLink = ({ link, title }) => {
  return (
    <div className="container lg:mt-8 xl-mt-2 lg:mb-2  mt-8 mb-1  flex lg:gap-7 gap-5 flex-col lg:flex-row justify-center">
      <a
        download={title}
        target="_blank"
        href={`${process.env.NEXT_PUBLIC_API_URL}${link}`}
        rel="noreferrer"
        className=" text-base xl:text-3xl hover:text-blue-medium text-blue-light group flex justify-center items-center"
      >
        <Icon
          type="download"
          className="w-6 h-6 mr-4 xl:w-7 xl:h-7 text-blue-light  group-hover:text-blue-medium"
        />
        <span className="">Jetzt PDF downloaden</span>
      </a>
    </div>
  );
};

export default PDFLink;
